/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertMinimalLegalEntityCommandDto
 */
export interface UpsertMinimalLegalEntityCommandDto {
    /**
     * ID of the legal entity to update. If null or not provided, a new entity will be created.
     * @type {string}
     * @memberof UpsertMinimalLegalEntityCommandDto
     */
    id?: string | null;
    /**
     * Name of the company/legal entity
     * @type {string}
     * @memberof UpsertMinimalLegalEntityCommandDto
     */
    companyName: string;
    /**
     * Email address of the legal entity
     * @type {string}
     * @memberof UpsertMinimalLegalEntityCommandDto
     */
    email: string;
}

/**
 * Check if a given object implements the UpsertMinimalLegalEntityCommandDto interface.
 */
export function instanceOfUpsertMinimalLegalEntityCommandDto(value: object): value is UpsertMinimalLegalEntityCommandDto {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UpsertMinimalLegalEntityCommandDtoFromJSON(json: any): UpsertMinimalLegalEntityCommandDto {
    return UpsertMinimalLegalEntityCommandDtoFromJSONTyped(json, false);
}

export function UpsertMinimalLegalEntityCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertMinimalLegalEntityCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['companyName'],
        'email': json['email'],
    };
}

export function UpsertMinimalLegalEntityCommandDtoToJSON(json: any): UpsertMinimalLegalEntityCommandDto {
    return UpsertMinimalLegalEntityCommandDtoToJSONTyped(json, false);
}

export function UpsertMinimalLegalEntityCommandDtoToJSONTyped(value?: UpsertMinimalLegalEntityCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'email': value['email'],
    };
}

